import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {materialColorOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {Three as THREE} from "#material/three/exports"
import {z} from "zod/v4-mini"

export interface ProvideThreeTextureSockets extends MaterialNodeSockets {
    inputs: {}
    settings: {}
    settingsExtensions: {
        color?: THREE.TextureNode
    }
    outputs: {
        color: "color"
    }
}

export const provideThreeTextureDefinition = {
    exchangeFormat: {
        nodeName: null,
    },
    nodeClass: "ProvideThreeTexture",
    ui: {
        color: "#4987af",
        items: [],
        label: "Provide Three Texture",
        support: {
            cycles: false,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({color: materialColorOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({}),
            settings: z.strictObject({color: z.optional(z.instanceof(THREE.TextureNode))}),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<ProvideThreeTextureSockets>
